"use client";

import Link from "next/link";

import { Button, type ButtonProps } from "@mantine/core";
import { sendGTMEvent } from "@next/third-parties/google";

import { SIGNUP_CTA } from "@/app/(marketing)/constants";

interface SignupCtaProps extends ButtonProps {
  /** GTM page identifier, ex: "platform" or "integrations" */
  page: string;
  /** GTM location identifier, ex: "hero" or "closing_cta" */
  location: string;
}

/** Client wrapper for the site-wide CTA button. Server-component pages cannot
    pass the Link component across the RSC boundary themselves, so they render
    this instead of Button + component={Link} directly. */
export default function SignupCta({ page, location, ...props }: SignupCtaProps) {
  return (
    <Button
      component={Link}
      size="md"
      href={SIGNUP_CTA.href}
      variant="gradient"
      gradient={{ from: "blue", to: "cyan", deg: 90 }}
      onClick={() =>
        sendGTMEvent({
          ...SIGNUP_CTA.gtm,
          page,
          location,
          button_style: "gradient",
        })
      }
      {...props}
    >
      {SIGNUP_CTA.label}
    </Button>
  );
}
